import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//

export default {
  props: {
    textStyle: {
      type: Object,
      default: function _default() {
        return {
          // 'font-size': ' 12px',
          // "color": '#00000',
          // 'text-align': 'center',
          // 'line-height': '32px',
          // 'font-weight': 'normal',
          // 'font-style': 'normal',
          // 'text-decoration': 'none',
        };
      }
    },
    value: {
      default: ''
    }
  },
  computed: {
    _style: function _style() {
      return _objectSpread(_objectSpread({}, this.textStyle), {}, {
        'line-height': this.textStyle['line-height'] + 'px',
        'font-size': this.textStyle['font-size'] + 'px'
      });
    }
  }
};